import React from 'react'
import { shallow, mount } from 'enzyme'
import { GenieTable, ascendingSort, descendingSort } from '../features/dashboard/GenieTable'
import Loader from '../../common/Loader'
import ErrorComponent from '../../common/Error'
import GenieTableHeader from '../features/dashboard/GenieTableHeader'
import GenieRow from '../features/dashboard/GenieRow'
import administrators from './testData/administrators'

describe('<GenieTable />', () => {
  let wrapper, instance, props
  beforeEach(() => {
    props = {
      perPage: 10,
      page: 1
    }
  })
  describe('when the query is loading', () => {
    beforeEach(() => {
      props = {
        ...props,
        data: {
          loading: true
        }
      }
      wrapper = shallow(<GenieTable {...props} />)
    })
    it('should render a <Loader />', () => {
      expect(wrapper.find(Loader)).toHaveLength(1)
    })
  })
  describe('when there is an error with the query', () => {
    beforeEach(() => {
      props = {
        ...props,
        data: {
          error: true
        }
      }
      wrapper = shallow(<GenieTable {...props} />)
    })
    it('should render an <Error />', () => {
      expect(wrapper.find(ErrorComponent)).toHaveLength(1)
    })
  })
  describe('when the query is completed successfully', () => {
    beforeEach(() => {
      props = {
        ...props,
        columns: [
          { title: 'test' },
          { title: 'onClick', onClick: jest.fn() }
        ],
        data: {
          administrators
        }
      }
      wrapper = shallow(<GenieTable {...props} />)
      instance = wrapper.instance()
    })
    describe('#render', () => {
      beforeEach(() => {
        instance.renderHeader = jest.fn()
        instance.renderRows = jest.fn()
      })
      it('should return something', () => {
        expect(instance.render()).toBeTruthy()
      })
      it('should call renderHaader if it is not loading and there is not an error', () => {
        instance.render()
        expect(instance.renderHeader).toHaveBeenCalled()
      })
      it('should call renderRows if it is not loading and there is no error', () => {
        instance.render()
        expect(instance.renderRows).toHaveBeenCalled()
      })
    })
    describe('#renderHeader', () => {
      it('should render a <GenieTableHeader />', () => {
        const header = mount(instance.renderHeader())
        expect(header.find(GenieTableHeader)).toHaveLength(1)
      })
    })
    describe('#renderRows', () => {
      beforeEach(() => {
        props = {
          ...props,
          perPage: 10,
          sortBy: 'value',
          page: 1
        }
      })
      it('should render a row for each admin up to the page limit', () => {
        const rows = mount(<div>{instance.renderRows()}</div>) // Wrap it in a div because enzyme requires a container element
        expect(rows.find(GenieRow)).toHaveLength(props.perPage)
      })
    })
    describe('#ascendingSort', () => {
      it('should sort admins in ascending order based on the specified property in their portfolio', () => {
        const sortedAdministrators = administrators.slice().sort(ascendingSort('value'))
        for (let i = 0; i < administrators.length; i++) {
          if (i > 0) {
            const prevAdmin = sortedAdministrators[i - 1]
            const currentAdmin = sortedAdministrators[i]
            expect(currentAdmin.portfolio.value).toBeGreaterThanOrEqual(prevAdmin.portfolio.value)
          }
        }
      })
    })
    describe('#descendingSort', () => {
      it('should sort admins in descending order bsed on the specified property in their portfolio', () => {
        const sortedAdministrators = administrators.slice().sort(ascendingSort('value'))
        for (let i = 0; i < administrators.length; i++) {
          if (i > 0) {
            const prevAdmin = sortedAdministrators[i - 1]
            const currentAdmin = sortedAdministrators[i]
            expect(currentAdmin.portfolio.value).toBeLessThanOrEqual(prevAdmin.portfolio.value)
          }
        }
      })
    })
  })
})
